(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suan-image-slideshow"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('suan-slideshow')) {

    class SuanSlideshow extends HTMLElement {

      connectedCallback() {

        if (this.initialised) return;

        this.initialised = true;

        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(
          this.querySelectorAll('[data-slide]')
        );

        this.dots = Array.from(
          this.querySelectorAll('[data-dot]')
        );

        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');

        this.index = 0;
        this.timer = null;
        this.pointerStartX = null;
        this.suppressClick = false;

        this.autoplayEnabled =
          this.dataset.autoplay === 'true' &&
          this.slides.length > 1;

        this.pauseOnHover =
          this.dataset.pauseHover === 'true';

        this.interval =
          Number(this.dataset.interval) || 5000;

        this.reducedMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

        if (!this.track || this.slides.length === 0) {
          return;
        }

        this.handlePrev = () => {
          this.goTo(this.index - 1, true);
        };

        this.handleNext = () => {
          this.goTo(this.index + 1, true);
        };

        this.handleKeydown = (event) => {

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.handlePrev();
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.handleNext();
          }

        };

        this.handleMouseEnter = () => {
          this.stopAutoplay();
        };

        this.handleMouseLeave = () => {
          this.startAutoplay();
        };

        this.handleVisibility = () => {

          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }

        };

        this.handlePointerDown = (event) => {

          if (event.pointerType === 'mouse') return;

          this.pointerStartX = event.clientX;

        };

        this.handlePointerUp = (event) => {

          if (this.pointerStartX === null) return;

          const distance =
            event.clientX - this.pointerStartX;

          this.pointerStartX = null;

          if (Math.abs(distance) < 45) return;

          this.suppressClick = true;

          if (distance < 0) {
            this.handleNext();
          } else {
            this.handlePrev();
          }

          window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);

        };

        this.handleClickCapture = (event) => {

          if (!this.suppressClick) return;

          event.preventDefault();
          event.stopPropagation();

        };

        this.handleBlockSelect = (event) => {

          const selectedIndex =
            this.slides.findIndex(
              (slide) =>
                slide.dataset.blockId ===
                event.detail.blockId
            );

          if (selectedIndex === -1) return;

          this.stopAutoplay();
          this.goTo(selectedIndex, false);

        };

        this.handleBlockDeselect = (event) => {

          const belongsToThisSlideshow =
            this.slides.some(
              (slide) =>
                slide.dataset.blockId ===
                event.detail.blockId
            );

          if (belongsToThisSlideshow) {
            this.startAutoplay();
          }

        };

        if (this.prevButton) {
          this.prevButton.addEventListener(
            'click',
            this.handlePrev
          );
        }

        if (this.nextButton) {
          this.nextButton.addEventListener(
            'click',
            this.handleNext
          );
        }

        this.dots.forEach((dot) => {

          dot.addEventListener('click', () => {

            this.goTo(
              Number(dot.dataset.index),
              true
            );

          });

        });

        this.addEventListener(
          'keydown',
          this.handleKeydown
        );

        this.track.addEventListener(
          'pointerdown',
          this.handlePointerDown,
          { passive: true }
        );

        this.track.addEventListener(
          'pointerup',
          this.handlePointerUp,
          { passive: true }
        );

        this.addEventListener(
          'click',
          this.handleClickCapture,
          true
        );

        document.addEventListener(
          'visibilitychange',
          this.handleVisibility
        );

        document.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect
        );

        document.addEventListener(
          'shopify:block:deselect',
          this.handleBlockDeselect
        );

        if (this.pauseOnHover) {

          this.addEventListener(
            'mouseenter',
            this.handleMouseEnter
          );

          this.addEventListener(
            'mouseleave',
            this.handleMouseLeave
          );

        }

        this.update();
        this.startAutoplay();

      }

      disconnectedCallback() {

        this.stopAutoplay();

        if (this.prevButton) {
          this.prevButton.removeEventListener(
            'click',
            this.handlePrev
          );
        }

        if (this.nextButton) {
          this.nextButton.removeEventListener(
            'click',
            this.handleNext
          );
        }

        this.removeEventListener(
          'keydown',
          this.handleKeydown
        );

        this.track?.removeEventListener(
          'pointerdown',
          this.handlePointerDown
        );

        this.track?.removeEventListener(
          'pointerup',
          this.handlePointerUp
        );

        this.removeEventListener(
          'click',
          this.handleClickCapture,
          true
        );

        this.removeEventListener(
          'mouseenter',
          this.handleMouseEnter
        );

        this.removeEventListener(
          'mouseleave',
          this.handleMouseLeave
        );

        document.removeEventListener(
          'visibilitychange',
          this.handleVisibility
        );

        document.removeEventListener(
          'shopify:block:select',
          this.handleBlockSelect
        );

        document.removeEventListener(
          'shopify:block:deselect',
          this.handleBlockDeselect
        );

      }

      goTo(nextIndex, userInitiated) {

        const slideCount = this.slides.length;

        this.index =
          (nextIndex + slideCount) % slideCount;

        this.update();

        if (userInitiated) {

          this.stopAutoplay();
          this.startAutoplay();

        }

      }

      update() {

        this.track.style.transform =
          `translate3d(-${this.index * 100}%, 0, 0)`;

        this.slides.forEach(
          (slide, slideIndex) => {

            const isActive =
              slideIndex === this.index;

            slide.setAttribute(
              'aria-hidden',
              isActive ? 'false' : 'true'
            );

            const link =
              slide.querySelector(
                '[data-slide-link]'
              );

            if (link) {
              link.tabIndex =
                isActive ? 0 : -1;
            }

          }
        );

        this.dots.forEach(
          (dot, dotIndex) => {

            const isActive =
              dotIndex === this.index;

            dot.classList.toggle(
              'is-active',
              isActive
            );

            dot.setAttribute(
              'aria-current',
              isActive ? 'true' : 'false'
            );

          }
        );

      }

      startAutoplay() {

        if (
          !this.autoplayEnabled ||
          this.reducedMotion ||
          document.hidden
        ) {
          return;
        }

        this.stopAutoplay();

        this.timer = window.setInterval(
          () =>
            this.goTo(
              this.index + 1,
              false
            ),
          this.interval
        );

      }

      stopAutoplay() {

        if (!this.timer) return;

        window.clearInterval(this.timer);

        this.timer = null;

      }

    }

    customElements.define(
      'suan-slideshow',
      SuanSlideshow
    );

  }


  } catch(e) { console.error(e); }
})();
})();
